import { Box, Flex } from 'components/elements'
import { ClaimStatus } from './enums'
import { StyledGradientDot, StyledGradientLine, StyledLineBoxWrap } from './style'
import ImageDocBox from 'features/insurance/components/ImageDocBox'

export type LossRunReportProps = {
  title: string
  threatName?: string
  classification?: string
  description?: string
  imageSrc?: string[]
  documentName?: string
  amount?: string
  time?: string
  show: boolean
  status?: string
  lossAmount?: string
}

const LossRunReport = ({ lossAmount, title, threatName, classification, description, imageSrc, documentName, amount, time, show, status }: LossRunReportProps) => {
  return (
    <Flex style={{ columnGap: 16 }}>
      {show && (
        <>
          <StyledLineBoxWrap>
            <StyledGradientDot />
            <StyledGradientLine />
          </StyledLineBoxWrap>
          <Box>
            <Box as="h4" style={{ marginBottom: 4 }}>
              {title} :
            </Box>
            {threatName && (
              <Box as="p" className="primary" style={{ marginBottom: 4 }}>
                ThreadInfo : {threatName}
              </Box>
            )}
            {classification && (
              <Box as="p" className="primary" style={{ marginBottom: 4 }}>
                Classification : {classification}
              </Box>
            )}
            {status && (
              <Flex style={{ columnGap: 8, marginBottom: 8 }} as="p" className="primary">
                Status :
                <Box as="p" css={{ marginBottom: 8, color: '$white' }}>
                  {status}
                </Box>
              </Flex>
            )}
            {status !== ClaimStatus.REJECTED && amount && (
              <Box as="p" style={{ marginBottom: 8 }}>
                {amount}
              </Box>
            )}
            {status !== ClaimStatus.REJECTED && lossAmount && (
              <Box as="p" style={{ marginBottom: 8 }}>
                {lossAmount}
              </Box>
            )}

            {description && (
              <Flex style={{ columnGap: 8, marginBottom: 8, whiteSpace: 'nowrap' }} as="p" className="primary">
                Justification :{' '}
                <Box as="p" css={{ marginBottom: 8, color: '$white', whiteSpace: 'normal' }}>
                  {description}
                </Box>
              </Flex>
            )}

            <ImageDocBox scourceData={imageSrc} documentName={documentName} hideLabel={true} />
            <Box as="p" className="small gray3">
              {time}
            </Box>
          </Box>
        </>
      )}
    </Flex>
  )
}

export const icons = {
  display: 'flex',
  alignItems: 'center',
  borderRadius: '$sm',
  columnGap: 15,
  padding: '.75rem 1.5rem',
  border: '1px solid $border',
  marginBottom: '.75rem',
  maxWidth: 400,
  width: '100%',
}

export default LossRunReport
